import clsx from 'clsx'
import { useEffect, type ReactNode } from 'react'
import { View } from 'react-native'
import Animated, { ReduceMotion, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated'

import { TEST_ID } from '@/src/general/constants/testId'

type TStepProps = {
  isActive?: boolean
  className?: string
}

export const BarStep = ({ isActive = false, className }: TStepProps): ReactNode => {
  const progress = useSharedValue(isActive ? 1 : 0)

  useEffect(() => {
    progress.value = withTiming(isActive ? 1 : 0, { duration: 300, reduceMotion: ReduceMotion.System })
  }, [isActive, progress])

  const animatedStyles = useAnimatedStyle(() => ({
    width: `${progress.value * 100}%`,
    height: '100%',
  }))

  return (
    <View
      testID={TEST_ID.ELEMENT.STEP}
      className={clsx('h-1.5 grow overflow-hidden rounded-full bg-primary-bg-high', className)}
      aria-checked={isActive}
    >
      <Animated.View style={animatedStyles}>
        <View className="h-full rounded-full bg-primary-bg-inverse" />
      </Animated.View>
    </View>
  )
}
